import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { BadgeCategorie, GetBadgesHttpResponse } from '../../../models/badge.model';


@Injectable({
  providedIn: 'root'
})
export class BadgeApi {
  constructor(private readonly http: HttpClient) { }

  getUserBadges(userId: number): Observable<BadgeCategorie[]> {
    const params = new HttpParams().set('userId', '' + userId);
    return this.http.get<GetBadgesHttpResponse>(environment.api.dashboard.userBadges, { params }).pipe(
      map(({ data }) => data)
    );
  }
}
